import React from 'react';
import Header from '../../Header/Header';
import { usePredictorStore } from '../../../store/predictor/predictorStore';
import { useEventStore } from '../../../store/event/eventStore';
import HowToPlay from '../../HowToPlay/HowToPlay';
import PrizePool from '../../PrizePool/PrizePool';
import { NextGameState, PlayState } from './StartScreen.functions';
import './StartScreen.scss';

const StartScreen = () => {
  const activePredictor = usePredictorStore((s) => s.activePredictor);
  const nextPredictor = usePredictorStore((s) => s.nextPredictor);
  const inPlay = useEventStore((s) => s.inPlay);
  const noGameState = !activePredictor && !nextPredictor;
  return (
    <div className={`start-screen-wrapper${noGameState ? '__no-game' : ''}`}>
      <Header showPrize={true} />
      <div className='start-screen'>
        {activePredictor && !inPlay ? <PlayState /> : <NextGameState />}
        {(!!nextPredictor || !!activePredictor) && (
          <>
            <div className='start-screen__how-to-play'>
              <HowToPlay />
            </div>
            <div className='start-screen__prize-pool'>
              <PrizePool />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default StartScreen;
